var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMymenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758020655959,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 40009,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.187431 235.50871m-69.997795 0a69.997795 69.997795 0 1 0 139.99559 0 69.997795 69.997795 0 1 0-139.99559 0Z",
    "p-id": 40010
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.505182 165.510915h552.305182v139.99559H347.505182z",
    "p-id": 40011
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.187431 512.1129m-69.997795 0a69.997795 69.997795 0 1 0 139.99559 0 69.997795 69.997795 0 1 0-139.99559 0Z",
    "p-id": 40012
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.505182 442.115105h552.305182v139.99559H347.505182z",
    "p-id": 40013
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.187431 788.49129m-69.997795 0a69.997795 69.997795 0 1 0 139.99559 0 69.997795 69.997795 0 1 0-139.99559 0Z",
    "p-id": 40014
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.505182 718.719294h552.305182v139.99559H347.505182z",
    "p-id": 40015
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymenu);
export default __webpack_public_path__ + "static/media/mymenu.126ecf99.svg";
export { ForwardRef as ReactComponent };